var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner flexColumn"},[_c('Grid',{attrs:{"GridStyle":{
            'grid-template-columns': 'repeat(10, 1fr)',
            'grid-template-rows': 'repeat(3, 1fr)',
            'font-size': '0.14rem',
            'grid-column': '1 / span 6',
            'height': '10%',
            'border': '1px solid #02d9fd',
            'background': '#02d9fd'
        },"gridDatas":{
            data: _vm.performenceData,
            settings: {
            0: {
                'grid-row': '1 / span 1',
                'grid-column': '1 / span 5'
            },
            1: {
                'grid-row': '1 / span 1',
                'grid-column': '6 / span 5'
            },
            2: {
                'grid-row': '2 / span 1',
                'grid-column': '1 / span 1'
            },
            3: {
                'grid-row': '2 / span 1',
                'grid-column': '2 / span 1'
            },
            4: {
                'grid-row': '2 / span 1',
                'grid-column': '3 / span 3'
            },
            5: {
                'grid-row': '2 / span 1',
                'grid-column': '6 / span 1'
            },
            6: {
                'grid-row': '2 / span 1',
                'grid-column': '7 / span 1'
            },
            7: {
                'grid-row': '2 / span 1',
                'grid-column': '8 / span 3'
            },
            8: {
                'grid-row': '3 / span 1',
                'grid-column': '1 / span 1'
            },
            9: {
                'grid-row': '3 / span 1',
                'grid-column': '2 / span 1'
            },
            10: {
                'grid-row': '3 / span 1',
                'grid-column': '3 / span 3'
            },
            11: {
                'grid-row': '3 / span 1',
                'grid-column': '6 / span 1'
            },
            12: {
                'grid-row': '3 / span 1',
                'grid-column': '7 / span 1'
            },
            13: {
                'grid-row': '3 / span 1',
                'grid-column': '8 / span 3'
            },
            }
        }}}),_c('div',{staticClass:"bottomBox"},[_c('box-border',{attrs:{"title":"风险跟踪","boxStyle":{
                'grid-column': '1 / span 2'
            }}},[_c('echart-module',{ref:"riskTrack",staticStyle:{"height":"100%","width":"100%"},attrs:{"option":_vm.riskTrack}})],1),_c('box-border',{attrs:{"title":"HSE Activities","boxStyle":{
                'grid-column': '3 / span 2'
            }}},[_c('echart-module',{ref:"Activities",staticStyle:{"height":"100%","width":"100%"},attrs:{"option":_vm.Activities}})],1),_c('box-border',{attrs:{"title":"Resume of HSE Events","boxStyle":{
                'grid-column': '5 / span 2'
            }}},[_c('echart-module',{ref:"HSEEvents",staticStyle:{"height":"100%","width":"100%"},attrs:{"option":_vm.HSEEvents}})],1),_c('box-border',{attrs:{"title":"NCR Status","boxStyle":{
                'grid-column': '1 / span 2'
            }}},[_c('echart-module',{ref:"NCRStatus",staticStyle:{"height":"100%","width":"100%"},attrs:{"option":_vm.NCRStatus}})],1),_c('box-border',{attrs:{"title":"CARs Status","boxStyle":{
                'grid-column': '3 / span 2'
            }}},[_c('echart-module',{ref:"CARsStatus",staticStyle:{"height":"100%","width":"100%"},attrs:{"option":_vm.CARsStatus}})],1),_c('box-border',{attrs:{"title":"QA/QC KPI","boxStyle":{
                'grid-column': '5 / span 2'
            }}},[_c('echart-module',{ref:"QAQCKPI",staticStyle:{"height":"100%","width":"100%"},attrs:{"option":_vm.QAQCKPI}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }